import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsViewBlueprintsRoute: InvariantJiraRoute = {
	name: 'polaris-settings-view-blueprints',
	path: '/jira/settings/products/jira-product-discovery/view-blueprints',
	exact: true,
};
